import smartSolveApi from './instances/smartsolve';

export const saveOfflineLog = async ({
  entityName,
  currentWorkflowId,
  itmId,
  stepId,
  workflowKey,
}) => {
  try {
    const response = await smartSolveApi.post('/offline/save', {
      entityName,
      currentWorkflowId,
      itmId,
      stepId,
      workflowKey,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getUserData() failed: ${e}`);
  }
};

export const discardOfflineLog = async ({
  entityName,
  currentWorkflowId,
  itmId,
  stepId,
  workflowKey,
}) => {
  try {
    const response = await smartSolveApi.post('/offline/discard', {
      entityName,
      currentWorkflowId,
      itmId,
      stepId,
      workflowKey,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getUserData() failed: ${e}`);
  }
};

export const synchronizeOfflineLog = async ({ entityName, submitworkflowdata }) => {
  try {
    const response = await smartSolveApi.post('/offline/synchronize', {
      entityName,
      ...submitworkflowdata,
    });

    return response.data;
  } catch (e) {
    throw new Error(`getUserData() failed: ${e}`);
  }
};
